import { getActiveFilterLabels, getCheckoutState, products, selectFood, shouldRefreshFlavours, storeBrandCopy } from './petyudo-store-rules.js';
import { renderCartLine, renderCheckoutPrompt, renderHeroCopy, renderProductCard, renderProductDetail } from './petyudo-render.js';

const state = { pet: 'all', series: 'all', cart: [] };
const productGrid = document.querySelector('#product-grid');
const cartPanel = document.querySelector('#cart-panel');
const backdrop = document.querySelector('.cart-backdrop');
const cartCounts = document.querySelectorAll('[data-cart-count]');
const cartTriggers = document.querySelectorAll('[data-cart-open]');
const cartLines = document.querySelector('#cart-lines');
const cartTotal = document.querySelector('#cart-total');
const deliveryZone = document.querySelector('#delivery-zone');
const deliveryQuote = document.querySelector('#delivery-quote');
const checkoutButton = document.querySelector('.checkout-button');
const checkoutPrompt = document.querySelector('#checkout-prompt');
const guideForm = document.querySelector('#food-guide');
const flavourSelect = document.querySelector('#flavour-select');
const guideResult = document.querySelector('#guide-result');
const productPanel = document.querySelector('#product-panel');
const productBackdrop = document.querySelector('.product-backdrop');
const productDetailContent = document.querySelector('#product-detail-content');
const activeFilters = document.querySelector('#active-filters');
const heroCopy = document.querySelector('#hero-copy');
const mobileMenu = document.querySelector('#mobile-menu');
const mobileMenuTrigger = document.querySelector('.menu-trigger');

const brand = storeBrandCopy();
document.querySelectorAll('[data-brand-lockup]').forEach((element) => {
  element.textContent = brand.name;
});

heroCopy.innerHTML = renderHeroCopy();

const getVisibleProducts = () => products.filter((product) =>
  (state.pet === 'all' || product.pet === state.pet) &&
  (state.series === 'all' || product.series === state.series),
);

function renderProducts() {
  productGrid.innerHTML = getVisibleProducts().map(renderProductCard).join('');
  const labels = getActiveFilterLabels(state.pet, state.series);
  activeFilters.innerHTML = labels.length
    ? `<span>目前篩選：${labels.join('、')}</span><button type="button" class="text-button" data-clear-filters>清除篩選</button>`
    : '<span>顯示全部 8 款首發商品</span>';
}

function cartSubtotal() {
  return state.cart.reduce((sum, item) => sum + item.price, 0);
}

function getSuggestedProduct(remaining) {
  return products
    .filter((product) => product.price >= remaining)
    .sort((first, second) => first.price - second.price)[0] || products[0];
}

function renderCart() {
  const subtotal = cartSubtotal();
  cartCounts.forEach((count) => { count.textContent = state.cart.length; });
  cartLines.innerHTML = state.cart.length ? state.cart.map(renderCartLine).join('') : '<li class="empty-cart">尚未加入商品。</li>';
  cartTotal.textContent = `MOP${subtotal}`;
  const checkout = getCheckoutState(deliveryZone.value, subtotal);
  const suggestion = checkout.eligible ? null : getSuggestedProduct(checkout.remaining);
  deliveryQuote.textContent = checkout.message;
  checkoutPrompt.innerHTML = renderCheckoutPrompt(checkout, suggestion);
  checkoutButton.disabled = !checkout.eligible;
  checkoutButton.textContent = checkout.eligible ? '付款通道審核中' : '尚未符合結帳資格';
}

function openCart() {
  cartPanel.setAttribute('aria-hidden', 'false');
  cartTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
  backdrop.hidden = false;
  toggleMobileMenu(false);
}

function closeCart() {
  cartPanel.setAttribute('aria-hidden', 'true');
  cartTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
  backdrop.hidden = true;
}

function toggleMobileMenu(open) {
  mobileMenu.setAttribute('aria-hidden', String(!open));
  mobileMenuTrigger.setAttribute('aria-expanded', String(open));
}

function openProductDetail(handle) {
  const product = products.find((item) => item.handle === handle);
  if (!product) return;
  productDetailContent.innerHTML = renderProductDetail(product);
  productPanel.setAttribute('aria-hidden', 'false');
  productBackdrop.hidden = false;
}

function closeProductDetail() {
  productPanel.setAttribute('aria-hidden', 'true');
  productBackdrop.hidden = true;
}

function updateFlavours() {
  const form = new FormData(guideForm);
  const matching = products.filter((product) => product.pet === form.get('pet') && product.series === form.get('series'));
  flavourSelect.innerHTML = matching.map((product) => `<option value="${product.flavour}">${product.flavour}</option>`).join('');
}

document.querySelectorAll('.filter-button').forEach((button) => {
  button.addEventListener('click', () => {
    const type = button.dataset.pet ? 'pet' : 'series';
    state[type] = button.dataset[type];
    document.querySelectorAll(`[data-${type}]`).forEach((item) => item.classList.toggle('active', item === button));
    renderProducts();
  });
});

activeFilters.addEventListener('click', (event) => {
  if (!event.target.closest('[data-clear-filters]')) return;
  state.pet = 'all';
  state.series = 'all';
  document.querySelectorAll('[data-pet]').forEach((item) => item.classList.toggle('active', item.dataset.pet === 'all'));
  document.querySelectorAll('[data-series]').forEach((item) => item.classList.toggle('active', item.dataset.series === 'all'));
  renderProducts();
});

productGrid.addEventListener('click', (event) => {
  const detailButton = event.target.closest('.product-detail-trigger');
  if (detailButton) {
    openProductDetail(detailButton.dataset.productHandle);
    return;
  }
  const button = event.target.closest('.add-to-cart');
  if (!button) return;
  const product = products.find((item) => item.handle === button.dataset.productHandle);
  state.cart.push(product);
  renderCart();
  openCart();
});

cartTriggers.forEach((trigger) => trigger.addEventListener('click', openCart));
document.querySelector('.cart-close').addEventListener('click', closeCart);
backdrop.addEventListener('click', closeCart);
deliveryZone.addEventListener('change', renderCart);
checkoutButton.addEventListener('click', () => {
  checkoutPrompt.innerHTML = '<p class="checkout-ready">付款通道仍在商戶批核及測試中；現時可先瀏覽商品與配送安排。</p>';
});

document.querySelector('.product-close').addEventListener('click', closeProductDetail);
productBackdrop.addEventListener('click', closeProductDetail);
productDetailContent.addEventListener('click', (event) => {
  const button = event.target.closest('.detail-add-to-cart');
  if (!button) return;
  const product = products.find((item) => item.handle === button.dataset.productHandle);
  state.cart.push(product);
  renderCart();
  closeProductDetail();
  openCart();
});

guideForm.addEventListener('change', (event) => {
  if (shouldRefreshFlavours(event.target.name)) updateFlavours();
});
guideForm.addEventListener('submit', (event) => {
  event.preventDefault();
  const values = new FormData(guideForm);
  const product = selectFood(values.get('pet'), values.get('series'), values.get('flavour'));
  guideResult.innerHTML = `<p>建議由 <strong>${product.title} · ${product.flavour}</strong> 開始。</p><button type="button" class="text-button" data-guide-product="${product.handle}">加入購物車</button>`;
});
guideResult.addEventListener('click', (event) => {
  const button = event.target.closest('[data-guide-product]');
  if (!button) return;
  state.cart.push(products.find((item) => item.handle === button.dataset.guideProduct));
  renderCart();
  openCart();
});

document.querySelectorAll('[data-pet-link]').forEach((link) => link.addEventListener('click', () => {
  state.pet = link.dataset.petLink;
  document.querySelectorAll('[data-pet]').forEach((item) => item.classList.toggle('active', item.dataset.pet === state.pet));
  renderProducts();
  toggleMobileMenu(false);
}));

mobileMenuTrigger.addEventListener('click', () => {
  toggleMobileMenu(mobileMenu.getAttribute('aria-hidden') === 'true');
});

renderProducts();
updateFlavours();
renderCart();
